import React, { useState } from 'react';
import { Helmet } from 'react-helmet';


export default function Refund(){

  const [page, setPage] = useState("terms");
  const [linkData] = useState();



  const link = linkData ? linkData[page] : null;

  return(
    <div className="home">
      <Helmet>
        <title>Trippie Air - Refund Policy</title>
        <meta name="description" content="Trippie Air" />
      </Helmet>
      <div className="home-hero bg-gradient">
        <div className="container-middle-content">
          <div className="about-header-text">
            <h1 className="medium-heading"> Refund Policy</h1>
            <p className="medium-para">
            Customer Delivery Cancellation and Refund Policy
            </p>
          </div>
        </div>
      </div>
      <div className="container-middle-content faq-container">
        <h6 style={{marginBottom: "2rem"}}>Once a delivery has been posted a Customer is still able to cancel this delivery request as long as no
delivery request has been marked as picked up. Full refunds will be given to those customers that had a
delivery request been cancelled before assigning them to drivers except when the payment is via Stripe in
which case the Stripe fee will be deducted before refunding the amount to the eWalllet of the Customer.</h6>

        <h6 style={{marginBottom: "1rem"}}>If the delivery request has been picked, then the Customer will not be able to cancel it. He/s needs to
contact Trippie Ltd manually (email/phone) to cancel it but no refund will be applied instead a New
delivery request will be created with a new delivery fee. If a customer cancels a delivery request after it
has been assigned to a driver, then he will be charged the processing fee and a refund of the remaining
amount will be issued to his/her eWallet. All refunds will be issued to the eWallet and no cash or money
transfer options are available.</h6>

      </div>
    </div>
  );
}
